import * as api from "./apis/login";
import { setTokens } from "./setTokens";
import { MfaRequiredError } from "../utils/GqlError";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
export { login };
async function login(params) {
  try {
    sendNewRelicEvent({
      EventName: 'login_start'
    });
    var tokens = await api.login(params);
    var idToken = tokens.idToken,
      accessToken = tokens.accessToken;
    sendNewRelicEvent({
      EventName: 'login_success'
    });
    emit('login.success', tokens);
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: true,
      broadcast: true,
      authActionType: 'login'
    });
    return tokens;
  } catch (e) {
    if (e instanceof MfaRequiredError) {
      emit('mfa required', e.mfaPayload);
    } else {
      var err = e;
      sendNewRelicEvent({
        EventName: 'login_failed',
        criticalError: err.criticalError,
        error_code: err.code,
        description: err.description
      });
      triggerError('login', e);
    }
    throw e;
  }
}